import { useRef, useState } from "react";

import { chapterRangeFor } from "@/data/chapter-range";
import { WHOLE_BOOK_SPAN_ID, type TimelineSpan } from "@/data/join-chapters";

export function useTimelineSpan(
  spans: readonly TimelineSpan[],
  initialSpanId: string | undefined,
): {
  spanId: string;
  setSpanId: (id: string) => void;
} {
  const routeId = initialSpanId !== undefined && chapterRangeFor(spans, initialSpanId) !== null
    ? initialSpanId
    : WHOLE_BOOK_SPAN_ID;
  const [spanId, setSpanIdState] = useState(routeId);
  const seenRoute = useRef(routeId);
  if (seenRoute.current !== routeId) {
    seenRoute.current = routeId;
    setSpanIdState(routeId);
  }

  const setSpanId = (id: string): void => {
    if (chapterRangeFor(spans, id) !== null) {
      setSpanIdState(id);
    }
  };

  return {
    spanId: chapterRangeFor(spans, spanId) !== null ? spanId : WHOLE_BOOK_SPAN_ID,
    setSpanId,
  };
}
